import React from 'react';
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { FormSubmitBtn } from 'src/buttons';
import { useTranslation } from 'react-i18next';

const DeleteMemoModal = ({ isOpen, hideModal, removeMemo }) => {
  const { t } = useTranslation();
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <React.Fragment>
        <CommonModal.Header hideModal={hideModal}>{t('features.Memos.components.DeleteMemoModal.Delete_memo')}</CommonModal.Header>
        <CommonModal.Body>
          <form>{t('features.Memos.components.DeleteMemoModal.Are_you_sure_you_want_to_delete_this_memo')}</form>
        </CommonModal.Body>
        <CommonModal.Footer>
          <Button onClick={hideModal} className="u-mr20">
            {t('features.Memos.components.DeleteMemoModal.Cancel')}
          </Button>
          <FormSubmitBtn text={t('features.Memos.components.DeleteMemoModal.Delete')} onClick={() => removeMemo()} />
        </CommonModal.Footer>
      </React.Fragment>
    </CommonModal>
  );
};

export default DeleteMemoModal;
